import { lazy } from 'react';

const CircularityCertificatesVerifierConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/verifier/consult/circularity-certificates',
			component: lazy(() => import('./CircularityCertificatesContainer'))
		}
	]
};

export default CircularityCertificatesVerifierConfig;
